import React, { useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';

import CompanyTemplates from './CompanyTemplates';
import PartnerTemplates from './PartnerTemplates';
import SearchFilters from './SearchFilters';

import { defaultActiveFilter } from 'components/projects/taskList/constants';
import { setCurrentTemplateId } from 'actions/todos';
import useCurrentCompany from '../../../../hooks/useCurrentCompany';
import useCompanyTaskListPartners from '../hooks/useCompanyTaskListPartners';
import useGetRecentTemplates from '../hooks/useGetRecentTemplates';

const messages = defineMessages({
  defaultFilterLabel: {
    id: 'Projects.taskList.templates.defaultFilter.label',
    defaultMessage: 'All Templates',
    description: 'Label for the default task list template filter',
  },
});

const Scroll = styled.div`
  overflow-y: scroll;
  height: 100%;
`;

const ListView = () => {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const {
    currentCompany: { node_id: companyNodeId, name: companyName },
  } = useCurrentCompany();
  const defaultFilter = {
    id: defaultActiveFilter,
    label: formatMessage(messages.defaultFilterLabel),
  };
  const { partners } = useCompanyTaskListPartners();
  const { data: recentTemplates } = useGetRecentTemplates();

  const templateFilters = [
    defaultFilter,
    {
      id: companyNodeId,
      label: companyName,
    },
    ...partners.map(({ id, name }) => {
      return {
        id,
        label: name,
      };
    }),
  ];
  const activeFilterId = useSelector(
    (state) => state.todos.templates.activeFilterId,
  );

  const ListViewBody = () => {
    switch (activeFilterId) {
      case defaultFilter.id:
        return (
          <CompanyTemplates
            includeAllTemplates
            recentTemplates={recentTemplates}
          />
        );
      case companyNodeId:
        return <CompanyTemplates includeAllTemplates={false} />;
      default:
        return <PartnerTemplates partnerId={activeFilterId} />;
    }
  };

  useEffect(
    () => {
      dispatch(setCurrentTemplateId(null));
    },
    [dispatch],
  );

  return (
    <>
      {partners.length ? <SearchFilters filters={templateFilters} /> : null}
      <Scroll>
        <ListViewBody />
      </Scroll>
    </>
  );
};

ListView.propTypes = {};

export default ListView;
